var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like_img_wrap cursor",on:{"click":_vm.likeMember}},[_c('div',{staticClass:"like_img",class:{'active': _vm.isMyLike()}}),_c('span',{staticClass:"like_count"},[_vm._v(_vm._s(_vm.returnCommas(_vm.likeData.likeCnt)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }